module.exports = __webpack_public_path__ + "img/base_template_image_en.ec68c5d3.png";